<template>
  <div>
    <section-heading :text="$t('COMMON.CHOOSE_STYLE')" />

    <v-container
      fluid
      :grid-list-lg="$vuetify.breakpoint.smAndDown"
      :grid-list-xxl="!$vuetify.breakpoint.smAndDown"
      text-xs-center
      pa-0
    >
      <v-layout row wrap>
        <v-flex xs6 sm6 md3 v-for="style in styles" :key="style.id">
          <v-hover>
            <base-card
              slot-scope="{ hover }"
              :class="{'scale-down' : hover}"
              :to="style.is_redirectable ? null : { path: style.path}"
              :href="style.is_redirectable ? style.url : null"
              :target="style.is_redirectable ? '_blank' : null"
              :rel="style.is_redirectable ? 'noreferrer' : null"
            >
              <tk-media
                :media="getMedia(style)"
                :style="{'background-color': getMedia(style).color }"
                aspect-ratio="1.5"
              />
              <div class="body-2 font-weight-medium pa-2">{{ getTitle(style) }}</div>
            </base-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import SectionHeading from "./SectionHeading.vue";

export default {
  components: {
    SectionHeading,
  },

  props: {
    styles: {
      required: true,
    },
  },

  computed: {
    arrtStyles() {},
  },

  methods: {
    getMedia(lift) {
      if (this.$vuetify.breakpoint.xsOnly) {
        return lift.mobile_media || lift.desktop_media || {};
      }
      return lift.desktop_media || lift.mobile_media || {};
    },

    getTitle(lift) {
      return lift.btn_title ? lift.btn_title[this.$i18n.locale] : "-";
    },
  },
};
</script>